import Phaser from 'phaser';

const RISE_PX = 30;
const LIFETIME_MS = 850;

export interface FloatingTextOptions {
  color: string;
  fontSize?: string;
}

/**
 * Número que sobe e some — o retorno visual de um golpe.
 *
 * O dano não é dedutível da barra de vida: dois golpes no mesmo tick apareceriam como
 * uma queda só, e um golpe que erra não mexe na barra. Por isso vem do pacote Combat,
 * que carrega evento, e não do Snapshot, que carrega estado.
 *
 * O tween destrói o objeto ao terminar, então não há pool a gerenciar nem vazamento se
 * a criatura sumir no meio da animação.
 */
export function spawnFloatingText(
  scene: Phaser.Scene,
  x: number,
  y: number,
  label: string,
  options: FloatingTextOptions,
): void {
  const text = scene.add.text(x, y, label, {
    fontFamily: 'ui-monospace, monospace',
    fontSize: options.fontSize ?? '14px',
    color: options.color,
    stroke: '#000000',
    strokeThickness: 3,
  });

  text.setOrigin(0.5, 1);
  text.setDepth(20);

  scene.tweens.add({
    targets: text,
    y: y - RISE_PX,
    alpha: 0,
    duration: LIFETIME_MS,
    ease: 'Cubic.easeOut',
    onComplete: () => text.destroy(),
  });
}
